import React from "react";
import Footer from "../../Components/UI/Footer/Footer";
import Header from "../../Components/UI/Header/Header";
import { Swiper, SwiperSlide } from "swiper/react";
import HomeImg from "../../assets/Guide/Guide1.jpg";
import HomeImg2 from "../../assets/Guide/Guide2.jpg";
import LoginImg from "../../assets/Guide/GuideLogin.png";
import GuideTabs from "../../assets/Guide/GuideTabs.png";
import GuideTable from "../../assets/Guide/GuideTable.png";
import GuideLakeSection from "../../assets/Guide/GuideLakeSection.png";
import GuideCv from "../../assets/Guide/GuideCv.jpg";
import GuideCv2 from "../../assets/Guide/GuideCv2.jpg";
import GuideListViewTab from "../../assets/Guide/GuideListViewTab.jpg";
import GuideListView from "../../assets/Guide/GuideListView.jpg";
import GuideButton from "../../assets/Guide/GuideButton.png";
import GuideMapTab from "../../assets/Guide/GuideMapTab.png";
import GuideMapSection from "../../assets/Guide/GuideMapSection.png";
import backGuide from "../../assets/Guide/back_guide.jpg";
// import arrowRightIcon from "../../assets/Guide/arrowRightIcon.png";
// import arrowLeftIcon from "../../assets/Guide/arrowLeftIcon.png";
import { Helmet } from "react-helmet";
import "./Guideline.scss";
import SwiperCore, { Navigation } from "swiper";
SwiperCore.use([Navigation]);

const Guideline = () => {
  const slides = [
    {
      title: "صفحه ورود",
      data: [
        {
          img: LoginImg,
          imgTitle: "شکل 1 - صفحه ورود به سامانه پایش دینامیک دریاچه ارومیه",
          description: `سامانه پایش دینامیک دریاچه ارومیه از طریق آدرس اینترنتی www.uldms.abopa.ir قابل دسترسی می باشد. برای ورد به سامانه ابتدا باید مطابق شکل 1 نام کاربری و رمز عبور را وارد کرده و دکمه ثبت را فشار دهید.`,
        },
      ],
    },
    {
      title: "صفحه خانه",
      data: [
        {
          img: GuideTabs,
          imgTitle: "",
          description: `پس از ورود به سامانه، در صفحه خانه مجموع مصارف سدهای حوضه آبریز دریاچه ارومیه از ابتدای سال آبی به تفکیک مصارف شرب، کشاورزی، دریاچه و صنعت در نمودارها ارائه شده است. همچنین در این نمودارها امکان مقایسه مقادیر محقق شده با برنامه منابع و مصارف اعلام شده از طرف وزارت نیرو، مقادیر مجموع مصارف تا روز مشابه در سال گذشته و همچنین مقادیر مجموع مصارف تا روز مشابه در بدترین سال آبی مشاهده شده در طول دوره دارای داده ثبت شده، وجود دارد. لازم به ذکر است که نمودارها به صورت دینامیک بوده و پس از هر بار به روزرسانی، تغییرات نمایش داده می شود. به این ترتیب، مدیران و تصمیم گیرندگان به راحتی در یک نگاه می توانند اطلاعات ارزشمندی را ملاحظه بفرمایند (شکل 2 - شماره 1) .`,
        },
        {
          img: HomeImg,
          imgTitle: "overview شکل 2 - صفحه خانه – بخش ",
          description: `در شکل 2 - شماره 2 جدول حاوی اطلاعات کلی برای تصمیم گیری در خصوص شرایط کلی حوضه ارائه شده است. این جدول حاوی اطلاعاتی به تفکیک دریاچه، مخازن موجود در حوضه آبریز دریاچه ارومیه و اطلاعات کلی حوضه می باشد. از جمله اطلاعاتی که در این بخش نمایش داده می¬شود در ارائه شده است. همانطور که ملاحظه می شود، تاریخ آخرین به روزرسانی در مقابل هر داده ارائه می شود تا تصمیم گیری در مورد کیفیت و کمیت داده ها راحت تر و قابل دسترس تر باشد.  `,
        },
        {
          img: HomeImg2,
          imgTitle: "",
          description: `برای دسترسی به سری زمانی اطلاعات کلی حوضه مربوط به هر یک از بخش های مشخص شده، می توان بر روی نماد ساعت که در شکل 2 (شماره 3) در کنار هر بخش نشان داده شده است کلیک کرد. به این ترتیب به صفحه سری های زمانی هدایت شده و می توان نمودار تغییرات زمانی هر یک از داده ها را برای هر بخش و با انتخاب تب مورد نظر ملاحظه کرد. تاریخ آخرین به روزرسانی به همراه آخرین مقدار ثبت شده در هر یک از تب ها نشان داده شده است. بنابراین در یک دید کلی به آخرین اطلاعات دسترسی وجود خواهد داشت. این نمودارها برای داده تراز دریاچه مربوط به بخش دریاچه در شکل 3 به عنوان نمونه نشان داده شده است. همچنین در این بخش امکان دانلود داده ها به فرمت CSV برای هر بازه زمانی دلخواه وجود دارد.`,
        },
        {
          img: GuideTable,
          imgTitle: "جدول 1 - داده های ارائه شده در صفحه خانه",
          description: `لازم به ذکر است که اطلاعات ارائه شده در این دو قسمت با هدف ارائه اطلاعات کلی حوضه و مخازن حوضه آبریز و شرایط کلی دریاچه ارائه شده است و اکثر مقادیر به صورت مجموع از ابتدای سال آبی ارائه می گردد. `,
        },
        {
          img: GuideLakeSection,
          imgTitle: "شکل 4 - صفحه خانه - بخش نمایش سیستمی",
          description: `در قسمت دوم سیستم رودخانه های حوضه به همراه سدهای مهم و تاثیرگذار در حوضه و همچنین ایستگاه های هیدرومتری جدید به صورت شماتیک، ارائه شده است. دراین قسمت مقادیر آخرین به روزرسانی برای هر ایستگاه هیدرومتری و سد ارائه شده است. همچنین تغییرات حجم موجود در مخازن به صورت شماتیک نمایش داده می¬شود. سطح دریاچه نیز که بر اساس تراز اندازه گیری شده در تاریخ مورد نظر و بر اساس معادله سطح-حجم-ارتفاع حاصل از مطالعات مرکز سنجش از دور دانشگاه صنعتی شریف در سال 1399 تعیین می گردد، به صورت شماتیک نشان داده می شود. به این ترتیب با مقایسه سطح دریاچه با کمترین و بیشترین سطح، می توان وضعیت سطح دریاچه را بررسی کرد. `,
        },
        {
          img: GuideCv2,
          imgTitle:
            "شکل 5 - نمودار تغییرات زمانی دبی ثبت شده در ایستگاه هیدرومتری شیشوان ",
          description: ``,
        },
        {
          img: GuideCv,
          imgTitle: "شکل 5 - نمودار تغییرات زمانی حجم مخزن سد بوکان",
          description: `در این بخش نیز با کلیک بر روی هر ایستگاه هیدرومتری و یا سد در حوضه آبریز می توان نمودار سری زمانی اطلاعات مربوطه را ملاحظه کرد. همچنین امکان دانلود این داده ها به فرمت CSV نیز وجود دارد و مقدار و تاریخ مربوط به داده ها با انتخاب هر یک از نقاط روی نمودار نمایش داده می شود.`,
        },
      ],
    },
    {
      title: "لیست داده ها",
      data: [
        {
          img: GuideListViewTab,
          imgTitle: "",
          description: `در این بخش تمامی داده های موجود به صورت لیست و به منظور دسترسی آسان تر ارائه شده است.`,
        },
        {
          img: GuideListView,
          imgTitle:
            "شکل 7- بخش لیست داده ها در سامانه پایش دینامیک حوضه آبریز دریاچه ارومیه",
          description: (
            <span>
              در این بخش امکان جستجو برای یافتن داده مورد نظر وجود دارد. لیست
              داده های ایستگاه سینوپتیک، هیدرومتری، هواشناسی و سدها به تفکیک
              ارائه شده است. در این لیست آخرین مقادیر ثبت شده در سایت به همراه
              تاریخ آن نمایش داده می شود. همچنین برای مشاهده سری زمانی تغییرات،
              می توان با کلیک بر روی <img src={GuideButton} alt="button" width="60" /> نمودار
              سری زمانی داده مورد نظر را ملاحظه کرد.
            </span>
          ),
        },
      ],
    },
    {
      title: "صفحه نقشه",
      data: [
        {
          img: GuideMapTab,
          imgTitle: "",
          description: `در این بخش داده های رستر و شیپ فایل مربوط به حوضه آبریز دریاچه ارومیه قابل نمایش می باشد. `,
        },
        {
          img: GuideMapSection,
          imgTitle:
            "شکل 8 - بخش نقشه در سامانه پایش دینامیک حوضه آبریز دریاچه ارومیه",
          description: ``,
        },
      ],
    },
  ];
  return (
    <>
      <Helmet>
        <title>راهنما</title>
      </Helmet>
      <Header />
      {/* <div
        style={{ backgroundImage: `url(${arrowRightIcon})` }}
        className="suggestionSwiperNextButton suggestionSwiperNextButtonClass"
      />
      <div
        style={{ backgroundImage: `url(${arrowLeftIcon})` }}
        className="suggestionSwiperPrevButton suggestionSwiperPrevButtonClass"
      /> */}
      <Swiper
        draggable={false}
        spaceBetween={0}
        slidesPerView={1}
        onSlideChange={() => console.log("slide change")}
        onSwiper={(swiper) => console.log(swiper)}
        navigation
      >
        {slides.map((slide) => (
          <SwiperSlide>
            <div className="main">
              <div style={{backgroundImage:`url(${backGuide})`,backgroundSize:"cover",backgroundRepeat:"no-repeat"}} className="left">
                {slide.data.map((item) => (
                  <>
                    <img className="image" alt={item.imgTitle} src={item.img} />
                    <h4>{item.imgTitle}</h4>
                    <div className="text-box">
                      <p className="text">{item.description}</p>
                    </div>
                  </>
                ))}
              </div>
              <div className="right">
                <h1>{slide.title}</h1>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <Footer />
    </>
  );
};

export default Guideline;
